export default __webpack_public_path__ + "assets/audios/6882ca36544371b78b1b9d86efc3ea10.mp3";